import {
  Box,
  ExpandableSection,
  SpaceBetween,
} from "@amzn/awsui-components-react";
import ReactJson from "react-json-view";
import { useContext } from "react";
import { DigitalCostDocument } from "../../../types";
import { StageContext } from "../../../contexes/OrderIdContext";
import { AsyncActionButton } from "../../common/AsyncActionButton";
import { usePaymentRedrive } from "../../../hooks/usePaymentRedrive";

interface DigitalCostDocumentViewProps {
  dcd: DigitalCostDocument;
  jsonViewProps: any;
}

export function DigitalCostDocumentView({
  dcd,
  jsonViewProps,
}: DigitalCostDocumentViewProps) {
  const stage = useContext(StageContext);
  const {
    status: redriveStatus,
    error: redriveError,
    redrive,
  } = usePaymentRedrive(stage);

  const isManualRoyaltyAdjustment = dcd.id.includes("ManualRoyaltyAdjustment");

  return (
    <SpaceBetween size="l">
      {isManualRoyaltyAdjustment && (
        <SpaceBetween direction="horizontal" size="xs">
          <AsyncActionButton
            label="Redrive Royalty Payment"
            successLabel="Redrive Submitted"
            failedLabel="Redrive Failed"
            status={redriveStatus}
            onClick={() => redrive(dcd.id)}
            errorMessage={redriveError}
          />
        </SpaceBetween>
      )}
      <ExpandableSection
        header={
          <Box variant="h4" margin={{ top: "xxs" }}>
            {dcd.id} (Digital Cost Document)
          </Box>
        }
        variant="container"
      >
        <ReactJson src={dcd.body} {...jsonViewProps} />
      </ExpandableSection>
    </SpaceBetween>
  );
}
